import React from "react";
import BaseSectionItem from "./BaseSectionItem";
import { menuData, showcaseData } from "../const/profileConstants";
import ShowcaseGroupItem from "./ShowcaseGroupItem";

export const ShowcaseSectionItem = () => {
  return (
    <BaseSectionItem header={menuData[2].value}>
      <div>
        <h5>
          <span className="text-danger">Enosis Web</span> development works are{" "}
          <span className="text-danger">not</span> displayed here as per company
          policy.
        </h5>
        <div>
          {showcaseData.map((item, index) => {
            return (
              <ShowcaseGroupItem
                index={index}
                data={item.projects}
                heading={item.heading}
                expandedByDefault={index === 0}
              />
            );
          })}
        </div>
      </div>
    </BaseSectionItem>
  );
};
